<div>
  {{ 'footer.copyrightText1' | translate }} {{ currentYear }}
  {{ 'footer.copyrightText2' | translate }}
</div>
<a (click)="goToLink(appSetting.privacyPolicyUrl)" target="currentwindow1">{{
  'footer.privacyStatement' | translate
}}</a>
<a (click)="goToLink(appSetting.termsOfUseUrl)" target="currentwindow2">{{
  'footer.termsOfService' | translate
}}</a>
